const styles = () => ({
    container: {
        position: 'relative',
        marginBottom: '30px',
    },
    containerHeader: {
        backgroundColor: '#fff',
    },
    back: {
        cursor: 'pointer',
        color: '#50585F',
        textDecoration: 'none',
        margin: '0 1em',
        height: '2.8em',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        fontSize: '1em',
        '& h2': {
            fontWeight: '400',
            marginLeft: '10px',
        },
    },

    home: {
        cursor: 'pointer',
        color: '#50585F',
        textDecoration: 'none',
        margin: '0',
        height: '2.8em',
        display: 'flex',
        alignItems: 'center',
        borderRight: '1px solid #ccc',
        paddingRight: '1em',
    },
});

export default styles;
